var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [_c("UiBadge", { attrs: { type: _vm.badgeType, label: _vm.eventLabel } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }